import { _ as _extends } from './_rollupPluginBabelHelpers-aa9fecf9.js';
import React__default, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FeedbackTooltip from './FeedbackTooltip.js';
import { I as InputIcon } from './InputIcon-67fd699a.js';
import { c as commonPropTypes } from './commonPropTypes-c0ea5832.js';
import { i as isFunction } from './helpers-4b4f63b7.js';
import { T as TooltipThemes, F as FormIntent, c as Themes } from './types-cb7b719f.js';
import './Tooltip-c1e96e39.js';
import '@tippy.js/react';
import './error-b4cacae8.js';
import './IconRouter.js';
import './add-db2cfe0c.js';
import './filter-d7318113.js';
import './loading-9570d856.js';
import './magnifying-glass-e8e7000e.js';
import './search-4c0fbfbf.js';
import './down-d5eefd55.js';
import './close-thin-b9d1e9c0.js';
import './tick-filled-19977a65.js';
import '@motorway/motorway-tools/typeHelpers';

var styles = {"select":"Select-module_select__2mfaL","greyText":"Select-module_greyText__1aXZs","input-icon":"Select-module_input-icon__2-D97","rightIcon":"Select-module_rightIcon__1tkPP","selectIntentError":"Select-module_selectIntentError__1Lloc","darkTheme":"Select-module_darkTheme__2OMKt","selectIntentSuccess":"Select-module_selectIntentSuccess__2bbK6","selectSmall":"Select-module_selectSmall__wueiA","selectWithIcon":"Select-module_selectWithIcon__uGlFu","control":"Select-module_control__3OKzr"};

const Select = ({
  children = null,
  className,
  defaultValue,
  feedbackTooltip = {},
  greyText = true,
  id = '',
  intent = null,
  label = '',
  labelProps = {},
  rightIcon = 'select',
  selectProps = {},
  size = 'normal',
  theme = Themes.LIGHT,
  value = ''
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const wrapperRef = useRef();
  useEffect(() => {
    setIsSelected(defaultValue || value);
  }, [defaultValue, value]);
  const onSelectChange = e => {
    const {
      onChange
    } = selectProps;
    if (isFunction(onChange)) {
      onChange(e);
    }
    setIsSelected(!!e.currentTarget.value);
  };
  if (label && !id) {
    // eslint-disable-next-line no-console
    console.warn(`Select element with the label "${label}" needs an ID attribute to associate label with the input`);
  }
  const selectContainerClass = cx(styles.select, {
    [styles.selectIntentError]: intent === FormIntent.ERROR,
    [styles.selectIntentSuccess]: intent === FormIntent.SUCCESS,
    [styles.selectSmall]: size === 'small',
    [styles.selectWithIcon]: rightIcon
  }, className);
  const selectClass = cx(styles.select, {
    [styles.greyText]: greyText && !isSelected,
    [styles.darkTheme]: theme === Themes.DARK
  }, selectProps.className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: selectContainerClass
  }, label && /*#__PURE__*/React__default.createElement("label", _extends({
    htmlFor: id
  }, labelProps), label), /*#__PURE__*/React__default.createElement(FeedbackTooltip, {
    appendTo: wrapperRef,
    content: feedbackTooltip.content,
    fillWidth: feedbackTooltip.fillWidth,
    intent: intent,
    placement: feedbackTooltip.placement,
    placementFlipped: feedbackTooltip.placementFlipped,
    theme: feedbackTooltip.theme || theme
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: wrapperRef,
    className: styles.control
  }, /*#__PURE__*/React__default.createElement("select", _extends({}, selectProps, {
    className: cx(selectClass, selectProps?.className),
    defaultValue: defaultValue,
    id: id,
    onChange: onSelectChange,
    value: value
  }), children), rightIcon && /*#__PURE__*/React__default.createElement(InputIcon, {
    className: styles.rightIcon,
    icon: rightIcon
  }))));
};
Select.propTypes = {
  children: commonPropTypes.children,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  feedbackTooltip: PropTypes.shape({
    content: commonPropTypes.children,
    fillWidth: PropTypes.bool,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'topLeft', 'topRight']),
    placementFlipped: PropTypes.string,
    theme: PropTypes.oneOf(Object.values(TooltipThemes))
  }),
  greyText: PropTypes.bool,
  id: PropTypes.string,
  intent: PropTypes.oneOf(Object.values(FormIntent)),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelProps: PropTypes.shape({}),
  rightIcon: PropTypes.string,
  selectProps: PropTypes.shape({
    className: commonPropTypes.className,
    onChange: PropTypes.func
  }),
  size: PropTypes.oneOf(['small', 'normal']),
  theme: PropTypes.oneOf(Object.values(Themes)),
  value: PropTypes.string
};

export { Select as default };
